function EditIcon(props) {
  let newProps = { ...props }
  let fillFirst = 'currentColor'
  let fillSecond = 'currentColor'
  if (props.fillFirst) {
    fillFirst = props.fillFirst
    delete newProps.fillFirst
  }
  if (props.fillSecond) {
    fillSecond = props.fillSecond
    delete newProps.fillSecond
  }

  return (
    <svg id='EditIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32.298 32.298' {...newProps}>
      <path
        id='Tracciato_73'
        data-name='Tracciato 73'
        d='M27.547,4.707,25.592,2.752a2.533,2.533,0,0,0-3.6,0L13,11.742V17.3h5.558L27.547,8.31a2.533,2.533,0,0,0,0-3.6ZM17.384,14.664H15.633V12.913L21.5,7.054,23.25,8.8Z'
        transform='translate(3.998 -1.999)'
        fill={fillFirst}
      />
      <path
        id='Tracciato_74'
        data-name='Tracciato 74'
        d='M30.2,30.2H6.4V6.4H16.6V3H6.4A3.41,3.41,0,0,0,3,6.4V30.2a3.41,3.41,0,0,0,3.4,3.4H30.2a3.41,3.41,0,0,0,3.4-3.4V20H30.2Z'
        transform='translate(-3 -1.299)'
        fill={fillSecond}
      />
    </svg>
  )
}

export default EditIcon
